const turkeyHotels = {
    47398: true,
    47414: true,
    47434: true,
    47435: true,
    47446: true,
    47531: true,
    47581: true,
    47582: true,
    47662: true,
    47739: true,
    47784: true,
    47789: true,
    47812: true,
    47902: true,
    47903: true,
    47922: true,
    47941: true,
    47947: true,
    48011: true,
    48159: true,
    48214: true,
    48224: true,
    48259: true,
    48279: true,
    48288: true,
    48315: true,
    48329: true,
    48333: true,
    48432: true,
    48504: true,
    48517: true,
    48525: true,
    48560: true,
    48588: true,
    48592: true,
    48635: true,
    48657: true,
    48681: true,
    48682: true,
    48718: true,
    48722: true,
    48735: true,
    48736: true,
    48741: true,
    48779: true,
    48780: true,
    48785: true,
    48804: true,
    48853: true,
    48860: true,
    48893: true,
    48914: true,
    49008: true,
    49054: true,
    49061: true,
    49069: true,
    49075: true,
    49100: true,
    49149: true,
    49153: true,
    49166: true,
    49167: true,
    49187: true,
    49246: true,
    49312: true,
    49359: true,
    49387: true,
    49388: true,
    49389: true,
    49490: true,
    49526: true,
    49542: true,
    49585: true,
    49587: true,
    49588: true,
    49601: true,
    49611: true,
    49613: true,
    49614: true,
    49626: true,
    49638: true,
    85298: true,
    85945: true,
    90557: true,
    97275: true,
    97508: true,
    98045: true,
    101095: true,
    101248: true,
    104259: true,
    104761: true,
    104931: true,
    105683: true,
    107613: true,
    107681: true,
    116346: true,
    127361: true,
    128244: true,
    129401: true,
    129406: true,
    129407: true,
    129522: true,
    129815: true,
    131713: true,
    132173: true,
    132367: true,
    144011: true,
    144037: true,
    266585: true,
    274640: true,
    274738: true,
    274914: true,
    276527: true,
    277267: true,
    279006: true,
    279022: true,
    281805: true,
    286603: true,
    288135: true,
    304961: true,
    306451: true,
    308790: true,
};

const UAEHotels = {
    276039: true,
    138503: true,
    12240: true,
    142071: true,
    111611: true,
    275692: true,
    281280: true,
    12392: true,
    11978: true,
    12224: true,
    100340: true,
    142170: true,
    134533: true,
    97398: true,
    276614: true,
    139988: true,
    12032: true,
    286527: true,
    12136: true,
    129527: true,
    12065: true,
    12041: true,
    12416: true,
    12102: true,
    288331: true,
    12279: true,
    131058: true,
    12382: true,
    101829: true,
    12170: true,
    135975: true,
    133332: true,
    11918: true,
    276204: true,
    269831: true,
    286568: true,
    12141: true,
    12185: true,
    131022: true,
    135561: true,
    133323: true,
    115474: true,
    12325: true,
    12386: true,
    12209: true,
    12025: true,
    280883: true,
    104832: true,
    276048: true,
    12236: true,
    284229: true,
    100231: true,
    247596: true,
    12050: true,
    12272: true,
    276335: true,
    12383: true,
    12085: true,
    104567: true,
    12436: true,
    100341: true,
    12311: true,
    11992: true,
    12151: true,
    136868: true,
    285827: true,
    11912: true,
    137429: true,
    11950: true,
    106734: true,
    140422: true,
    12320: true,
    129349: true,
    12235: true,
    12027: true,
    12344: true,
    12200: true,
    12165: true,
    12191: true,
    144194: true,
    140693: true,
    11988: true,
    140702: true,
    12269: true,
    292644: true,
    300906: true,
    12161: true,
    137368: true,
    11958: true,
    284515: true,
    12263: true,
    106732: true,
    105098: true,
    11974: true,
    97103: true,
    298610: true,
    12418: true,
    12308: true,
    12321: true,
    12154: true,
    12100: true,
    134531: true,
    104833: true,
    12239: true,
    142207: true,
    12223: true,
    11991: true,
    106603: true,
    12204: true,
    12162: true,
    12385: true,
    104224: true,
    133891: true,
    12007: true,
    138932: true,
    12037: true,
    12218: true,
};
const thailandHotels = {
    120579: true,
    16532: true,
    106787: true,
    15698: true,
    138187: true,
    132050: true,
    132021: true,
    167891: true,
    16569: true,
    16083: true,
    111629: true,
    221467: true,
    276458: true,
    106471: true,
    263360: true,
    16121: true,
    16761: true,
    16418: true,
    16836: true,
    17009: true,
    16849: true,
    16777: true,
    15685: true,
    142690: true,
    15800: true,
    302439: true,
    130431: true,
    16096: true,
    106660: true,
    16519: true,
    16474: true,
    15723: true,
    15636: true,
    65948: true,
    16562: true,
    111624: true,
    16196: true,
    110256: true,
    16565: true,
    16405: true,
    16855: true,
    106451: true,
    15981: true,
    65330: true,
    142620: true,
    325313: true,
    131196: true,
    142383: true,
    16220: true,
    16374: true,
    15970: true,
    16765: true,
    15966: true,
    16235: true,
    16067: true,
    16420: true,
    15790: true,
    15986: true,
    16679: true,
    16234: true,
    65619: true,
    15985: true,
    16897: true,
    16191: true,
    105141: true,
    16155: true,
    16535: true,
    16190: true,
    16591: true,
    16758: true,
    286046: true,
    16835: true,
    104844: true,
    15704: true,
    16541: true,
    110168: true,
    16152: true,
    16678: true,
    65305: true,
    16230: true,
    16771: true,
    17069: true,
    139574: true,
    16215: true,
    16690: true,
    65853: true,
    16636: true,
    16360: true,
};

export default {
    ...turkeyHotels,
    ...UAEHotels,
    ...thailandHotels,
};